<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_8.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">1、</div>
				<div class="step_txt">
					<div>
						取出拭子，注意不要触碰拭子头部。
					</div>
					<!-- <div class="txt_note">
						Note: Be careful not to touch the swab tip (soft end) with hand.
					</div> -->
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_9.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">2、</div>
				<div class="step_txt">
					<div >
						样本采集时，先用卫生纸擤去鼻涕，小心拆开拭子外包装，避免手部接触拭子头。随后头部微仰，一手执拭子尾部贴一侧鼻孔进入，沿下鼻道的底部向后缓缓深入1-1.5厘米（对于年龄2-14岁受试者，深入1厘米）后贴鼻腔旋转至少5圈，随后使用同一拭子对另一鼻腔重复相同操作。将拭子头浸入检测试纸条配套的含处理液的采样容器中。
					</div>
					<!-- <ul>
						<li>
							Carefully insert the swab tip into one nostril about
							<span class="col-red">3/4 inch</span>. &nbsp;Firmly and slowly rotate the swab 5 times, &nbsp;
							brushing against the inside walls of the nostril to ensure 
							both mucus and cells are collected.
						</li>
						<li>
							Using the <span class="col-red">same swab</span>, &nbsp;repeat this process for the
							other nostril to ensure an adequate sample is collected 
							from both nostrils.
						</li>
					</ul> -->
				</div>
			</div>
			
			<!-- <div class="step_el">
				<div class="tit">3、</div>
				<div class="step_txt" style="padding-top: 1.2rem;">
					<div>
						采集样本后应尽快对拭子进行处理。能在24小时内检测的标本可置2℃〜8℃保存。长期保存需冷冻于-20℃以下，忌反复冻融。
					</div>
					<div class="txt_note">
						注意：
						<div>
							采样规范性会对检测结果有影响，建议采样人员应是专业人员、或经过专业人员指导和培训的人员。
						</div>
						<div>
							一次性采样拭子只能搭配同一人份的样本处理液使用，并且仅可用于采集同一人的样本，禁止混用。
						</div>
						<div>
							采样过程中应避免采样拭子被污染，采样后应立即检测。
						</div>
					</div>
				</div>
			</div> -->
		</div>
		<div class="btn_box">
			<van-button
				type="primary"
				block
				color="#4f56fe"
				@click="goStepFour"
			>
				下一步
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			//
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			shareUrl(that);
		});
		that.$router.afterEach((to, from, next) => {
			window.scrollTo(0, 0);
		})
	},
	watch: {
		//
	},
	methods: {
		goStepFour() {
			this.$router.push({path:'/stepthree'});
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100%;
	background-color: #fbfbfb; */
}
.step_box{
	position: relative;
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.step_box .step_el{
	background-color: #ffffff;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	position: relative;
	border: 1px solid #E9E9E9;
}
.step_box .step_el:last-child{
	margin-bottom: 0;
}
/* .step_box, .btn_box{background-color: #fbfbfb;} */
.step_box{padding-bottom: 0.64rem !important;}
/*步骤下说明文字*/
.step_txt{
	padding: 0.533rem 0.64rem 0.427rem 0.64rem;
	color: #333333;
}

.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el:last-child{
	padding-bottom: 0;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{padding:0rem 0.9rem 1.107rem 0.9rem;}
.step_box img, .btn_box img{width: 100%;}

.step_txt .pad_bot{
	padding-bottom: 0.1rem;
}
.step_txt .txt_note{
	padding-top: 0.427rem;
	color: #720000;
	font-weight: bold;
}
ul li{
	padding: 0 0 0.1rem 0;
}
ul li:last-child{
	padding-bottom: 0;
}


>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}
</style>
